module.exports = __webpack_public_path__ + "img/reset-icon.5d210a50.svg";